export enum EPaymentMethodType {
  SBP = 'sbp',
  LinkedCard = 'linkedCard',
  Others = 'others',
}

export type TPaymentMethods = { [key: string]: IPaymentMethod };

export interface IPaymentMethod {
  type: EPaymentMethodType;
  name: string;
  paymentProvider: EPaymentProvider;
  min: number;
  max: number | undefined;
  warning: string | null;
  linkedCard: ILinkedCardData | null;
}

export interface ILinkedCardData {
  id: number;
  cardType: EPaymentCardType | null;
  cardNumber: string;
  bankType: EBankType | null;
}

export enum EPaymentProvider {
  YooKassa = 'yooKassa',
  CloudPayments = 'cloudPayments',
}

export enum EPaymentCardType {
  AmericanExpress = 'americanExpress',
  Maestro = 'maestro',
  MasterCard = 'mastercard',
  Mir = 'mir',
  UnionPay = 'unionpay',
  Visa = 'visa',
  VisaElectron = 'visaElectron',
}

export enum EBankType {
  Absolut = 'absolut',
  Alfa = 'alfa',
  Domrf = 'domrf',
  Gazprom = 'gazprom',
  MTS = 'mts',
  Otkrytie = 'otkrytie',
  PSB = 'psb',
  Raiffeisen = 'raiffeisen',
  Rencredit = 'rencredit',
  Rosbank = 'rosbank',
  RSHB = 'rshb',
  Sber = 'sber',
  SMP = 'smp',
  Sovcom = 'sovcom',
  Tinkoff = 'tinkoff',
  UBRR = 'ubrr',
  Unicredit = 'unicredit',
  Uralsib = 'uralsib',
  VTB = 'vtb',
}
